import React, { useState, useEffect, useRef, useCallback } from "react";
import TakafulDataService from "../services/TakafulService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const TakafulList = (props) => {
  const [takaful, setTakaful] = useState([]);
  const takafulRef = useRef();
  takafulRef.current = takaful;

  let { owner } = useParams();

  const retrieveTakaful = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    TakafulDataService.getAll(target)
      .then((response) => {
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.takaful ?? payload;
        setTakaful(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("TakafulList.retrieveTakaful error:", e?.response?.status, e?.response?.data || e?.message || e);
        setTakaful([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveTakaful();
  }, [retrieveTakaful]);

  const deleteTakaful = useCallback((rowIndex) => {
    const id = takafulRef.current[rowIndex].id || takafulRef.current[rowIndex]._id;
    TakafulDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/takaful");
        const newArr = [...takafulRef.current];
        newArr.splice(rowIndex, 1);
        setTakaful(newArr);
      })
      .catch((e) => {
        console.error("deleteTakaful error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/takaful/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/takaful/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = takafulRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteTakaful(idx);
  }, [deleteTakaful]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={takaful}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/takaful/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Takaful Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default TakafulList;
